import envColors from './env-colors.json';

export type AdminEnvironmentKey = 'dev' | 'stage' | 'prod' | 'main';

export function getAdminEnvironmentKey(): AdminEnvironmentKey {
    const raw = String(import.meta.env.VITE_ENVMENT ?? import.meta.env.MODE ?? '').trim().toLowerCase();

    if (raw.includes('dev')) return 'dev';
    if (raw.includes('stage')) return 'stage';
    if (raw.includes('prod') || raw.includes('production')) return 'prod';
    if (raw.includes('main')) return 'main';

    return 'dev';
}

export function getAdminChromeColor() {
    const environmentKey = getAdminEnvironmentKey();

    return (envColors as Record<string, string>)[environmentKey] ?? envColors.dev;
}

export function getAdminEnvironmentLabel() {
    return getAdminEnvironmentKey().toUpperCase();
}
